(function () {
  'use strict';

  /* @ngdoc object
   * @name itecAdministracio.api.logout
   * @description
   *
   */
  angular
    .module('itecAdministracio.api.logout', [

    ]);
}());
